import { createContext } from "react";

const SegmentsContext = createContext();

export default SegmentsContext;
